import storyType from "./story-type"

const cardMapping = (card, dictionary) => {
  const cardTitle =
    card._type === "faq_glossary"
      ? `${
          card.faqGlossarySport
            ? card.faqGlossarySport.name
            : dictionary.find(
                (dictionaryItem) => dictionaryItem.key.current === "general"
              )?.value
        } ${
          dictionary.find(
            (dictionaryItem) => dictionaryItem.key.current === card.type
          )?.value
        }`
      : card.detailed_title || card.title

  const cardSlug =
    card._type === "faq_glossary"
      ? {
          current: card.faqGlossarySport
            ? card.faqGlossarySport.slug.current
            : "general",
        }
      : card.slug

  const presentingPartner = card.presenting_partners?.find(
    (b) => !b.country || b.country.abbreviation === process.env.GATSBY_COUNTRY
  )

  const cardPartner = presentingPartner
    ? presentingPartner.partner
    : card.partner

  return {
    ...card,
    sport: card.faqGlossarySport ? [card.faqGlossarySport] : card.sport,
    title: cardTitle,
    slug: cardSlug,
    partner: cardPartner,
    storyType: storyType({
      item: card,
      dictionary,
      type: card.web_article_type || card._type || card.type,
    }),
  }
}

export default cardMapping
